// extracted by mini-css-extract-plugin
export default {"SVG":"DragDrop_SVG__g3HA9","CenterAdjust":"DragDrop_CenterAdjust__01goK","Input":"DragDrop_Input__p0J--"};